




















import { computed, defineComponent } from '@nuxtjs/composition-api';
import { ISbRichtext, ISbStoryData } from '@storyblok/js/dist/types';
import { renderRichText } from '~/modules/storyblok/helpers/renderRichText';

export default defineComponent({
  props: {
    blok: {
      type: Object,
      required: true,
    },
  },
  setup({ blok }) {
    const content = computed(() => blok.block);
    const richText = computed(
      (): ISbRichtext | string => (typeof blok.rich_text === 'string' ? blok.rich_text : renderRichText(blok.rich_text as ISbStoryData)),
    );

    return {
      content,
      richText,
    };
  },
});
